import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'translateKeys' })
export class TranslateKeysPipe implements PipeTransform {
    private translateService = inject(TranslateService);

    transform<T extends Record<string, any>>(obj: T, keys: Array<keyof T>): T {
        keys.forEach(key => {
            const value = obj[key];
            if (typeof value === 'string' && value) {
                obj[key] = this.translateService.instant(value) as T[typeof key];
            }
        });

        return obj;
    }
}
